import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { usePlanById } from '../../../hooks/requests/use-plan-by-id';
import { useValidatedParams } from '../../../hooks/use-validated-params';
import { PlanContent } from './plan-view-page-components/PlanContent';

export const PlanViewPage: React.FC = () => {
  const { planId } = useValidatedParams<['planId']>('planId');
  const { data } = usePlanById(planId, { suspense: false });
  const plan = useMemo(() => data?.plan, [data]);

  return (
    <>
      <Helmet>
        <title>{`Plan ${plan?.name ?? ''}`}</title>
      </Helmet>

      <VyLayout>
        <PlanContent planId={planId} />
      </VyLayout>
    </>
  );
};
